var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.423828,
    width: 120.056,
    height: 120.056,
    rx: 32.7425,
    fill: "#5886FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2017_6747)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.252,
    y: 32.7427,
    width: 76.3991,
    height: 58.6636,
    rx: 12.2372,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.4153 44.1483C20.2248 39.1815 24.5427 28.6548 33.2819 28.6548H88.4569C96.797 28.6548 100.488 39.0883 93.8581 44.1483V44.1483C85.818 50.2848 74.675 58.1473 67.443 63.1849C63.109 66.2038 57.3307 66.0545 53.1088 62.8808C46.1555 57.654 35.4375 49.6895 27.4153 44.1483V44.1483Z",
    fill: "#BCC5DD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2017_6747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.3991,
    height: 61.3922,
    fill: "white",
    transform: "translate(22.252 30.0142)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuMailIcon);
export default __webpack_public_path__ + "static/media/zunu_mail_icon.213ad6dfe4cd14682cdc93d8ea13dd2e.svg";
export { ForwardRef as ReactComponent };